import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import React from 'react'

const Model = ({open,setOpen,children,size}) => {
  return (
    <>
     <Dialog open={open} onClose={setOpen} className="relative z-[999]">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-back_drop_black/80 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
      />

      <div className="fixed inset-0 z-[99] w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className={`relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full ${size||"sm:max-w-sm"} sm:p-6 data-closed:sm:translate-y-0 data-closed:sm:scale-95`}
          >
            <div>
{children}
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog> 
    </>
  )
}

export default Model
